/**
 * Celá obrazovka.
 *
 * Prehliadač ju pustí **len z kliknutia človeka** – samo sa to zapnúť nedá,
 * a preto sa o to pokúšame pri kliknutí na Baliaci stôl v menu a pri tlačidle
 * na obrazovke. Keď to prehliadač odmietne, nič sa nedeje: ostane obyčajné
 * okno a klávesa F11 funguje ako vždy.
 */
export function celaObrazovka(zapnut) {
  try {
    if (zapnut && !document.fullscreenElement) document.documentElement.requestFullscreen?.();
    if (!zapnut && document.fullscreenElement) document.exitFullscreen?.();
  } catch { /* prehliadač to odmietol */ }
}

/**
 * Chce tento stôl celú obrazovku?
 *
 * ── Odkiaľ to prišlo ─────────────────────────────────────────────────────
 * Oto: *„Nech to baliace okno neostáva úplne zablokované. Áno, nech ho
 * maximalizuje vždy a dá do plného okna, ale aby sa dalo napr. Esc dostať
 * naspäť, aby bolo vidieť celé okno."*
 *
 * Celá obrazovka je pri stole správna: obrazovka patrí objednávke a adresný
 * riadok tam nikto nepotrebuje. Lenže občas treba naspäť do okna – prepnúť
 * na inú kartu, pozrieť tlačiareň, nastaviť Windows. Vtedy sa stlačí Esc.
 *
 * **Pamätá sa to len do zavretia karty** (`sessionStorage`), a to zámerne.
 * Keby sa to pamätalo natrvalo, jedno stlačenie Esc by stôl už nikdy
 * neroztiahlo a nikto by nevedel prečo. Takto platí pravidlo „ráno sa zapne
 * počítač a stôl je na celú obrazovku" vždy, a zároveň sa nikto do nej
 * nevracia proti svojej vôli.
 */
const KLUC_CELA = 'fs_stol_cela';

export const chceCeluObrazovku = () => {
  try { return sessionStorage.getItem(KLUC_CELA) !== 'nie'; } catch { return true; }
};

export const zapamatajCelu = (naCelu) => {
  try { sessionStorage.setItem(KLUC_CELA, naCelu ? 'ano' : 'nie'); } catch { /* súkromné okno */ }
};
